module.exports = __webpack_public_path__ + "static/images/index-gift-box.c895af9.png";